import { InsuranceType, SelectedInsuranceFragment } from '@websky/graphql';
import { InsuranceDownloadAction } from './types';

export const canDownloadInsurancePolicy = (params: {
	isConfirmed: boolean;
	policyUrl?: string | null;
	insuranceType?: InsuranceType | null;
}): boolean => {
	const { isConfirmed, policyUrl, insuranceType } = params;

	return isConfirmed && (!!policyUrl || insuranceType === InsuranceType.Vsk);
};

export const getInsuranceDownloadAction = (params: {
	isConfirmed: boolean;
	policyUrl?: string | null;
	insuranceType?: InsuranceType | null;
	onDownloadVsk?: () => Promise<void>;
}) => {
	if (!canDownloadInsurancePolicy(params)) {
		return null;
	}

	if (params.policyUrl) {
		return { downloadUrl: params.policyUrl };
	}

	if (params.insuranceType === InsuranceType.Vsk && params.onDownloadVsk) {
		return { onDownload: params.onDownloadVsk };
	}

	return null;
};

export const getSelectedInsuranceDownloadAction = (
	insurance: SelectedInsuranceFragment,
	isConfirmed: boolean,
	onDownloadVsk?: () => Promise<void>
): InsuranceDownloadAction | null =>
	getInsuranceDownloadAction({
		isConfirmed,
		policyUrl: insurance.policyUrl,
		insuranceType: insurance.insuranceProgram?.type,
		onDownloadVsk
	});

export const executeInsuranceDownload = async (action: InsuranceDownloadAction): Promise<void> => {
	if (action.downloadUrl) {
		window.open(action.downloadUrl, '_blank');

		return;
	}

	if (action.onDownload) {
		await action.onDownload();
	}
};
